export function select2JS($) {
  $(document).ready(function () {
    $(".select2").select2({
      maximumSelectionLength: 3,
      placeholder: "select up to 3",
      allowClear: true,
    });

    const inquireSelect = $("#inquire");
    const purposeOfLoans = $("#purposeOfLoans").parent();
    const plannedLoanAmount = $("#plannedLoanAmount").parent();

    // Function to toggle visibility
    function toggleLoanFields() {
        const selectedOptions = inquireSelect.val() || [];

        if (selectedOptions.includes("Term Loans") || selectedOptions.includes("Credit Line")) {
            purposeOfLoans.show();
            plannedLoanAmount.show();
        } else {
            purposeOfLoans.hide();
            plannedLoanAmount.hide();
        }
    }

    // Hide fields initially
    purposeOfLoans.hide();
    plannedLoanAmount.hide();

    // Add event listener to select element
    inquireSelect.on("change", function() {
        toggleLoanFields();
    });
  });

  // $(function () {
  //   var today = moment(); // Current date
  //   $('input[name="PreferredDate"]').daterangepicker({
  //     autoUpdateInput: false, // Do not automatically update input field
  //     locale: {
  //       cancelLabel: "Clear",
  //     },
  //     singleDatePicker: true, // Use a single date picker (not a range)
  //     showDropdowns: true, // Show month and year dropdowns
  //     minDate: today, // Limit to today and future dates only
  //     opens: "center", // Optionally, open the calendar at the center of the screen
  //   });

  //   // Handle date range application
  //   $('input[name="PreferredDate"]').on(
  //     "apply.daterangepicker",
  //     function (ev, picker) {
  //       var start = picker.startDate;
  //       var end = start.clone().add(2, "days"); // Add 2 days to create a 3-day range
  //       $(this).val(
  //         start.format("MM/DD/YYYY") + " - " + end.format("MM/DD/YYYY")
  //       );
  //       $(this).data("start-date", start); // Store start date for future reference
  //     }
  //   );

  //   // Clear the input field when canceled
  //   $('input[name="PreferredDate"]').on(
  //     "cancel.daterangepicker",
  //     function (ev, picker) {
  //       $(this).val("");
  //     }
  //   );
  // });

  $(function () {
    var today = moment(); // Current date

    $('input[name="PreferredDate"]').daterangepicker({
      autoUpdateInput: false,
      locale: {
        cancelLabel: "Clear",
      },
      singleDatePicker: true,
      showDropdowns: true,
      minDate: today,
      opens: "center",
      isInvalidDate: function (date) {
        return date.day() === 0 || date.day() === 6; // Disable Sundays (0) and Saturdays (6)
      },
    });

    // Handle date selection
    $('input[name="PreferredDate"]').on('apply.daterangepicker', function (ev, picker) {
      var start = picker.startDate.clone();
      var weekdays = [start];

      // Collect 2 more weekdays (excluding weekends)
      while (weekdays.length < 3) {
        start.add(1, 'day');
        if (start.day() !== 0 && start.day() !== 6) {
          weekdays.push(start.clone());
        }
      }

      // Format the date range display
      var displayRange =
        weekdays[0].format("MM/DD/YYYY") +
        " - " +
        weekdays[2].format("MM/DD/YYYY");

      $(this).val(displayRange);
      $(this).data("start-date", weekdays[0]);
      $(this).data("end-date", weekdays[2]);
    });

    // Clear input when canceled
    $('input[name="PreferredDate"]').on('cancel.daterangepicker', function () {
      $(this).val('');
    });
  });



}
